import mixin from '../../../../mixins/mixin';
import DatePicker from 'vue2-datepicker';
import moment from 'moment/moment';
import Vue from 'vue';
import bookingService from '../../../../services/booking';
import accountService from '../../../../services/account';
import bookingStatusService from '../../../../services/booking_status';
import formService from "../../../../services/form";

export default {
  name: 'ScheduleCalendar',
  data() {
    return {
      selectedDay: moment().format('MMM DD, YYYY'),
      lastPage: 0,
      limit: 10,
      page: 0,
      loading: false,
      bookingsCheckings: [],
      bookingsCheckouts: [],
      teamMembers: [],
      statuses: [],
      statusCounts: {
        toBeAssigned: 0,
        assigned: 0,
        done: 0,
        cleaningFast: 0,
        cancelled: 0,
      },
      selectedMember: 'selected',
      bookingItem: [],
      guestItem: [],
      bookingDetails: false,
      rentalItem: [],
      channelItem: [],
      bookingIndex: null,
      user: {
        is_team_member: '',
        rights: {},
        booking_statuses: [],
      },
      editable: {
        toBeAssigned: false,
        assigned: false,
        done: false,
        cleaningFast: false,
        cancelled: false,
      },
      checkingsChecked: false,
      checkoutsChecked: false,
      isAtLeastOneBookingChecked: false,
      rentals: [],
      showBookingActions: false,
      showBookingPrices: false,
      selectedDate: '',
      membersForChecking: [],
      membersForCheckout: [],
      bookingUrl: null
    };
  },
  components: {
    DatePicker,
    VManageLocks: require('components/manage-locks/manage-locks.vue'),
    VLoading: require('components/loading/loading.vue')
  },
  props: {
    'checkedRentals': Object
  },
  mixins: [ mixin ],
  async mounted() {
    const vm = this;
    this.loading = true;
    Vue.filter('getWeekDayFromDate', date => moment(date).format('ddd DD MMMM . YYYY'));
    let rentalIds = this.getCheckedRentalIds(this.checkedRentals);
    await this.getBookingsForSelectedDay(rentalIds);
    await bookingStatusService.getAllStatuses(vm);
    await accountService.getUserWithStatuses(vm);

    $('.panel-overlay').click(() => {
      vm.closeDetailModal();
    });
  },
  watch: {
    'user.booking_statuses': {
      handler: function () {
        this.generateBookingStatuses();
      },
      deep: true,
    },
  },
  methods: {
    async changeDay(day) {
      const vm = this;
      let date;
      const today = moment();

      if (day == 'prev') {
        date = moment(vm.selectedDay, 'MMM DD, YYYY').subtract(1, 'days');
      } else if (day == 'next') {
        date = moment(vm.selectedDay, 'MMM DD, YYYY').add(1, 'days');
      } else {
        date = moment(vm.selectedDay, 'MMM DD, YYYY');
      }
      const newDate = date.format('MMM DD, YYYY');
      vm.selectedDay = newDate;
      this.selectedDate = date.format('YYYY-MM-DD');
      let rentalIds = this.getCheckedRentalIds(this.checkedRentals);
      await bookingService.getBookingsSelectedDay(vm, this.selectedDate, rentalIds);
      await vm.checkCheckedBookings();
    },
    getClass(status) {
      let assignClass = '';
      switch (status) {
        case 1:
          assignClass = 'to-be-assigned';
          break;
        case 2:
          assignClass = 'assigned';
          break;
        case 3:
          assignClass = 'done';
          break;
        case 4:
          assignClass = 'cancelled';
          break;
        case 5:
          assignClass = 'cleaning';
          break;
      }
      return assignClass;
    },
    getStatusName(id) {
      const vm = this;
      if (vm.user.booking_statuses || id === false) {
        const index = vm.user.booking_statuses.findIndex(x => x.status_id === id);
        if (index === -1) {
          return false;
        }
        return vm.user.booking_statuses[index].name;
      }
      return false;
    },
    calculateCounts() {
      const vm = this;
      if (vm.bookingsCheckings.length) {
        for (let i = 0; i < vm.bookingsCheckings.length; i++) {
          if (vm.bookingsCheckings[i].checking_assign_status) {
            switch (vm.bookingsCheckings[i].checking_assign_status.id) {
              case 1:
                vm.statusCounts.toBeAssigned++;
                break;
              case 2:
                vm.statusCounts.assigned++;
                break;
              case 3:
                vm.statusCounts.done++;
                break;
              case 4:
                vm.statusCounts.cancelled++;
                break;
              case 5:
                vm.statusCounts.cleaningFast++;
                break;
            }
          }
          Vue.set(vm.bookingsCheckings[i], 'checked', false);
        }
      }
      // End

      // Count Checkout Statuses
      if (vm.bookingsCheckouts.length) {
        for (let j = 0; j < vm.bookingsCheckouts.length; j++) {
          if (vm.bookingsCheckouts[j].checkout_assign_status) {
            switch (vm.bookingsCheckouts[j].checkout_assign_status.id) {
              case 1:
                vm.statusCounts.toBeAssigned++;
                break;
              case 2:
                vm.statusCounts.assigned++;
                break;
              case 3:
                vm.statusCounts.done++;
                break;
              case 4:
                vm.statusCounts.cancelled++;
                break;
              case 5:
                vm.statusCounts.cleaningFast++;
                break;
            }
          }
          Vue.set(vm.bookingsCheckouts[j], 'checked', false);
        }
      }
    },
    async addOrChangeTeamMember(bookingIndex, bookingId, memberId, type) {
      const vm = this;
      const data = {
        bookingId,
        memberId,
        type
      };
      await bookingService.assignTeamMemberToBooking(vm, data, bookingIndex, type);
      await vm.checkCheckedBookings();
    },
    async changeAssignStatus(bookingIndex, bookingId, statusId, type) {
      const vm = this;
      const data = {
        bookingId,
        statusId,
        type
      };
      await bookingService.changeAssignStatus(vm, data, bookingIndex, type);
    },
    async assignCheckedBookingsToMember() {
      const vm = this;
      if (vm.selectedMember == 'selected') {
        return;
      }
      const data = {};
      const checkingLength = vm.bookingsCheckings.length;
      const checkoutLength = vm.bookingsCheckouts.length;
      const checkingBookingIds = [];
      const checkoutBookingIds = [];
      const checkoutBookingIndex = [];
      const checkingBookingIndex = [];

      for (let i = 0; i < checkingLength; i++) {
        if (vm.bookingsCheckings[i].checked) {
          checkingBookingIds.push(vm.bookingsCheckings[i].id);
          checkingBookingIndex.push(i);
        }
      }
      for (let j = 0; j < checkoutLength; j++) {
        if (vm.bookingsCheckouts[j].checked) {
          checkoutBookingIds.push(vm.bookingsCheckouts[j].id);
          checkoutBookingIndex.push(j);
        }
      }

      data.checking = checkingBookingIds;
      data.checkout = checkoutBookingIds;
      data.member = vm.selectedMember;
      if (checkingBookingIds.length == 0 && checkoutBookingIds.length == 0) {
        return;
      }
      await bookingService.assignMemberToChecked(vm, data, checkingBookingIndex, checkoutBookingIndex);
      await vm.checkCheckedBookings();
    },
    async showDetail(index, booking, rental) {
      const vm = this;
      this.bookingUrl = this.getBookingUrl(booking, rental);
      vm.bookingDetails = true;
      vm.bookingItem = booking;
      vm.guestItem = booking.guest;
      vm.rentalItem = rental;
      vm.channelItem = booking.channel;
      vm.bookingIndex = index;

      if (vm.user && vm.user.rights) {
        const rights = Object.values(vm.user.rights);
        const rightExists = rights.find(item => item.parent_id == vm.bookingItem.rental.user_id);
        vm.showBookingActions = (rightExists && rightExists.booking_actions);
        vm.showBookingPrices = (rightExists && rightExists.booking_prices);
      }

      if (vm.rentals && vm.rentals.length > 0) {
        vm.rentals.map((rental) => {
          if (rental.id === booking.rental_id) {
            if (rental.the_keys_locks && rental.the_keys_locks.length > 0) {
              vm.bookingItem.rental.the_keys_locks = rental.the_keys_locks;
              booking.areLocksConnectedToBookingRental = true;
            } else {
              booking.areLocksConnectedToBookingRental = false;
            }
          }
        });
      } else {
        booking.areLocksConnectedToBookingRental = false;
      }
      $('.panel-overlay').fadeIn();
      $('.ninja-btn,.panel').addClass('active');
      $('.ninja-btn,.panel').css({ right: '0' });
      $('.pannel_sec_second').css({ right: '-350px' });

      await bookingService.getBookingsSelectedDay(this, booking.checking, [], true);
      await bookingService.getBookingsSelectedDay(this, booking.checkout, [], true);
    },
    closeDetailModal() {
      const vm = this;
      $('.ninja-btn, .panel').removeClass('active');
      $('.panel-overlay').fadeOut();
      $('.pannel_sec_second').css({ right: '-350px' });
      vm.bookingDetails = false;
    },
    toBooking(id, tab, isViewBooking = false) {
      const vm = this;
      vm.closeDetailModal();
      if (!isViewBooking) {
        Vue.router.push({
          name: 'bookings.details.tab',
          params: { id, tab },
        });
      }
    },
    onChangeFollowUp() {
      const vm = this;
      vm.bookingItem.first_name = vm.bookingItem.guest.first_name;
      vm.bookingItem.last_name = vm.bookingItem.guest.last_name;
      vm.bookingItem.email = vm.bookingItem.guest.email;
      vm.bookingItem.phone = vm.bookingItem.guest.phone;
      bookingService.updateBooking(vm.bookingItem, this);
    },
    async autoSave(field, status_id, e) {
      const vm = this;

      vm.editable[field] = !vm.editable[field];

      const data = {
        field,
        status_id,
        name: e.target.value,
      };

      await bookingStatusService.updateBookingStatus(vm, data);
    },
    enableEditing(field) {
      const vm = this;
      vm.editable[field] = !vm.editable[field];
      vm.$nextTick(() => {
        if (vm.$refs[field] && vm.$refs[field][0]) {
          vm.$refs[field][0].focus();
        } else {
          vm.$refs[field].focus();
        }
      });
    },
    getStatusTranslation(status) {
      const vm = this;
      switch (status) {
        case 1:
          return vm.$t('calendar.jobs.to_be_assigned');
        case 2:
          return vm.$t('calendar.jobs.assigned');
        case 3:
          return vm.$t('calendar.jobs.done');
        case 4:
          return vm.$t('calendar.jobs.cancelled');
        case 5:
          return vm.$t('calendar.jobs.cleaning_fast');
        case false:
          return '';
      }
    },
    async checkOrUncheckBookings(type) {
      const vm = this;
      if (type == 'checking') {
        if (vm.bookingsCheckings.length) {
          for (let i = 0; i < vm.bookingsCheckings.length; i++) {
            vm.bookingsCheckings[i].checked = vm.checkingsChecked;
          }
        }
      } else if (vm.bookingsCheckouts.length) {
        for (let j = 0; j < vm.bookingsCheckouts.length; j++) {
          vm.bookingsCheckouts[j].checked = vm.checkoutsChecked;
        }
      }
      await vm.checkCheckedBookings();
    },
    checkCheckedBookings() {
      const vm = this;
      const checkedBookingCheckin = vm.bookingsCheckings.filter(bookingChecking => bookingChecking.checked == true);
      const checkedBookingCheckout = vm.bookingsCheckouts.filter(bookingCheckout => bookingCheckout.checked == true);
      if (checkedBookingCheckin.length > 0 || checkedBookingCheckout.length > 0) {
        vm.isAtLeastOneBookingChecked = true;
      } else {
        vm.isAtLeastOneBookingChecked = false;
      }
      if (checkedBookingCheckin.length === vm.bookingsCheckings.length) {
        vm.checkingsChecked = true;
      } else {
        vm.checkingsChecked = false;
      }
      if (checkedBookingCheckout.length === vm.bookingsCheckouts.length) {
        vm.checkoutsChecked = true;
      } else {
        vm.checkoutsChecked = false;
      }
    },
    generateBookingStatuses() {
      const newStatuses = [];
      if (this.user.booking_statuses.length) {
        this.statuses.forEach((status) => {
          if (!this.user.booking_statuses.find(bookingStatus => bookingStatus.status_id === status.id)) {
            newStatuses.push({ id: status.id, name: this.getStatusTranslation(status.id) });
          }
        });
        this.user.booking_statuses.forEach((status) => {
          if (!newStatuses.find(newStatus => newStatus.id === status.status_id)) {
            newStatuses.push({ id: status.status_id, name: status.name });
          }
        });
        newStatuses.sort((a, b) => a.id - b.id);
        this.statuses = newStatuses;
      }
    },
    getBookingsForSelectedDay(rentalIds) {
      let selectedDay = this.selectedDate ? this.selectedDate : moment().format('YYYY-MM-DD');
      bookingService.getBookingsSelectedDay(this, selectedDay, rentalIds)
    },
    getCheckedRentalIds(checkedRentals) {
      let rentalIds = [];
      for (const id in checkedRentals) {
        if (checkedRentals[id] === true) {
          rentalIds.push(parseInt(id));
        }
      }
      return rentalIds;
    },
    showCheckingCheckoutAssignName(booking, type) {
      if (type === 'checking' && booking.checking_assign && booking.checking_assign.id) {
        return `${booking.checking_assign.first_name} ${booking.checking_assign.last_name}`;
      } else if (type === 'checkout' && booking.checkout_assign && booking.checkout_assign.id) {
        return `${booking.checkout_assign.first_name} ${booking.checkout_assign.last_name}`;
      }

      return '';
    },
    changeFormStatus(type, booking) {
      const data = {
        'id': booking.id,
        'welcome_form_submitted': booking.welcome_form_submitted,
        'checkin_form_submitted': booking.checkin_form_submitted,
        type
      };

      formService.changeFormStatus(this, data);
    }
  },
  computed: {
    account() {
      return this.$store.state.account;
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/pages/calendar/scheduler/assign/assign.js